import { FC, useEffect, useMemo } from 'react'

import { SubmitInspectionResponseHeader } from './SubmitInspectionResponseHeader'
import { SubmitInspectionResponseForm } from './SubmitInspectionResponseForm'
import { DLMSiteApplication } from '../../../core/doclabel'

type Props = {
  site: DLMSiteApplication
  doClose: Function
}

const SubmitInspectionResponseModal: FC<Props> = ({site, doClose}) => {

  const { siteState, siteID, appID, siteROIS, projectName, projectLocation } = useMemo(() => {        
    if (! site) return { siteState : '', siteID : 0, appID: 0, siteROIS: [], projectName: '', projectLocation: ''};
    const { state: siteState, id: siteID, dlmApplication, rois: siteROIS, projectName, projectLocation } = site;
    const { id: appID  } = dlmApplication;

    return { siteState, siteID, appID, siteROIS, projectName, projectLocation } 
  }, [site]);
  
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
  <>
  <div
    className='modal fade show d-block'
    id='kt_submit_inspection_response_modal'
    role='dialog'
    tabIndex={-1}
    aria-modal='true'
  >    
    <div className='modal-dialog modal-dialog-centered mw-600px'>    
      <div className='modal-content'>
        <SubmitInspectionResponseHeader siteState={siteState} doClose={doClose} />                
        <div className='modal-body py-4'>
          <SubmitInspectionResponseForm 
            siteID={siteID} 
            siteState={siteState} 
            projectName={projectName}
            projectLocation={projectLocation}
            appID={appID ? appID : 0}
            siteROIS={siteROIS}
            doClose={doClose}                     
          />
        </div>                
      </div>            
    </div>            
  </div>    
  <div className='modal-backdrop fade show'></div>    
  </>
  )
}

export {SubmitInspectionResponseModal}
